import React from 'react';
import { CreateDialogPanel, IUpdateDialogProps } from '../../layout/panels/ViewPanel';
import {
  requestAccessSubmitConfig as config,
  getRequestAccessPageInitialValues as getInitialValues,
  getRequestAccessMutation as getMutation,
} from '../../services/GraphQLTypes';
import { RequestAccessPageFormPage } from '../form/RequestAccessFormPage';

export function RequestAccessPageUpdateDialog(props: IUpdateDialogProps): React.ReactElement {
  return (
    <CreateDialogPanel
      config={config}
      parent={props.dataItem}
      parentAccessor="parent"
      getInitialValues={getInitialValues}
      getMutation={getMutation}
      component={RequestAccessPageFormPage}
      onClickOk={props.onClickOk}
      onClickCancel={props.onClickCancel}
      visible={props.visible}
    />
  );
}
